import { RowSelectionOptions } from '@ag-grid-community/core';
import { Component } from '@angular/core';
import { Addon } from 'app/model/entities/addon';
import { AgFns } from 'app/shared/ag-fns';
import _ from 'lodash';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DbQueryService } from './db-query.service';
import { EntityFinderDialog } from './entity-finder.dialog';

export interface AddonFinderParams {
  accountId: number;
  rowSelection?: RowSelectionOptions;
}

@Component({
    template: EntityFinderDialog.HTML,
    host: { 'hostID': crypto.randomUUID().toString() },
    standalone: false
})
export class AddonFinderDialogComponent extends EntityFinderDialog<Addon, AddonFinderParams> {

  constructor(
    ref: DynamicDialogRef,
    config: DynamicDialogConfig<AddonFinderParams>,
    public dbQueryService: DbQueryService,
  ) {
    super(ref, config);

    Object.assign(this.config, {
      header: `Select Addon(s)`,
      width: '800px',
      height: '530px',
    });
  }

  override async initDatasource() {
    if (this.params.accountId == null) {
      let q = this.dbQueryService.createAddonFinderQuery();
      const ds = AgFns.buildDatasource(() => q);
      return ds;
    } else {
      let addons = await this.dbQueryService.getAddons(this.params.accountId)
      addons = _.orderBy(addons, ao => ao.nameAndLocation);
      return addons;
    }
  }

  override getColDefsAndSortModel() {
    const colDefs = [
      { headerName: 'Addon', field: 'nameAndLocation' , filter: 'agTextColumnFilter' },
      { headerName: 'Addon Station', field: 'addonStation.name', filter: 'agTextColumnFilter' },
      { headerName: 'Account', field: 'account.accountName', filter: 'agTextColumnFilter' },
      { headerName: 'Id', field: 'id', filter: 'agNumberColumnFilter' },
    ];

    const sortModel = [
      { colId: 'nameAndLocation', sort: 'asc' as const },
    ];
    return [colDefs, sortModel] as const;
  }


}
